import { TableCell } from '@mui/material';
import styled from 'styled-components';
import { COLORS } from 'theme/colors';

const cellHeights = {
  condensed: '10px',
  regular: '16px',
  relaxed: '18px',
  default: '16px',
};

type TableCellHeight = keyof Omit<typeof cellHeights, 'default'>;
const getCellHeight = (height?: TableCellHeight) =>
  height ? cellHeights[height] : cellHeights['default'];

export const StyledTableHeadCell = styled(TableCell)<{
  height?: TableCellHeight;
}>`
  position: relative;
  font-size: 0.9rem;
  font-weight: 600;
  vertical-align: middle;
  line-height: 1rem;
  && {
    ${({ height }) =>
      height &&
      `
        padding: ${getCellHeight(height)} 16px;
    `}
  }
  &&:not(:last-child)::after {
    content: '';
    height: 28%;
    width: 2px;

    position: absolute;
    margin-left: 20px;
    right: 0;
    top: 36%;
    bottom: 36%;

    background-color: ${COLORS.GRAY_2};
  }
`;

export const StyledTableCell = styled(TableCell)<{
  height?: TableCellHeight;
  fontWeight?: number;
  $disabled?: boolean;
}>`
  && {
    font-size: 0.9rem;
    padding: ${({ height }) => `${getCellHeight(height)} 16px`};
    &&:hover {
      cursor: ${({ $disabled }) => (!$disabled ? 'pointer' : 'default ')};
    }
    font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : 500)};
  }
`;
